module.exports = __webpack_public_path__ + "static/media/Scrimba_logo.7d10714b.png";